// extracted by mini-css-extract-plugin
export default {"container":"_0aYKV0G1--styles_container__sM6qp","infoText":"_0aYKV0G1--styles_infoText__c-RML","button":"_0aYKV0G1--styles_button__1yOqg"};